var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error_container"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("@/assets/image/404.png"),"alt":""}})]),_c('span',[_vm._v("店铺链接失效或店铺信息异常，请重新访问")])])
}]

export { render, staticRenderFns }